// StarAnimation.js
var StarAnimation = pc.createScript('starAnimation');

StarAnimation.attributes.add("pointA", {type: "entity", title: "Point A"});
StarAnimation.attributes.add("pointB", {type: "entity", title: "Point B"});

StarAnimation.prototype.initialize = function() {
    this.speed = 5;
    this.time = 0;
};

StarAnimation.prototype.update = function(dt) {
    this.time += dt; 
    if (this.time > this.speed) {
        this.time -= this.speed;
    }    
    var percent = this.time / this.speed;
    var position = this.entity.getPosition();
    position.lerp(this.pointA.getPosition(), this.pointB.getPosition(), percent);
    if(position.x > 0.93){
        this.entity.destroy();
    }
    this.entity.setPosition(position);
};

StarAnimation.prototype.SpeedUpdate = function(){
    if(this.speed === 1){return;}
    this.speed -= 0.25;
};

StarAnimation.prototype.SpeedReset = function(){
    this.speed = 5;
};

